if (!customElements.get("collection-slider-tabs")) {
	customElements.define(
		"collection-slider-tabs",
		class CollectionSliderTabs extends HTMLElement {
			constructor() {
				super()

				this.TAB_CONTAINER = this.querySelector(".cs-tabs__tabs .tabs")

				if (!this.TAB_CONTAINER) return

				this.TAB_CONTAINER.addEventListener("click", this.initTabs.bind(this))

				var sliders = this.querySelectorAll(".cs-tabs__slider")

				var swiper_settings = {
					slidesPerView: 2,
					spaceBetween: 10,
					// enabled: false,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					breakpoints: {
						750: {
							slidesPerView: 4,
							spaceBetween: 30,
						},
					},
					on: {
						init: function (slider) {
							if (slider.params.slidesPerView == 2) {
								this.disable()
							}
						},
					},
					mousewheel: {
						forceToAxis: true,
					},
				}

				Array.from(sliders).forEach((slider) => {
					var swiper_container = slider.querySelector(".swiper")
					let swiper = new Swiper(swiper_container, swiper_settings)

					swiper.on("breakpoint", function (swiper, breakpointParams) {
						console.log("breakpoint", breakpointParams)
						if (breakpointParams.slidesPerView == 2) {
							swiper.disable()
						} else {
							swiper.enable()
						}
					})
				})
			}

			initTabs(e) {
				const tab = e.target.closest('.tabs__item:not([aria-selected="true"])')
				// debugger
				if (!tab) return

				var selected_index = tab.dataset.index
				var matching_slider = this.querySelector(`.cs-tabs__slider[data-index="${selected_index}"]`)

				if (!matching_slider) return

				//changed selected tab
				const current_active_tab = this.querySelector('.tabs__item[aria-selected="true"]')
				current_active_tab.setAttribute("aria-selected", false)
				tab.setAttribute("aria-selected", true)

				//handle slider
				const current_active_slider = this.querySelector('.cs-tabs__slider[aria-selected="true"]')
				current_active_slider.setAttribute("aria-selected", false)
				matching_slider.setAttribute("aria-selected", true)
			}
		}
	)
}
